import React, { useEffect, useRef, useState } from "react";

import "./checkbox-ing.css";

export default function Checkbox({
  typeCheck = "checked",
  name,
  id,
  checked,
  defaultChecked,
  onChange,
  className = "",
  title,
  onClick,
  radioBox,
  value,
  disabled = false,
  readOnly = false,
}) {
  return (
    <div className="checkbox-container">
      {typeCheck !== "checked" ? (
        <input
          disabled={disabled}
          className={`inputs__filter-checkbox ${
            radioBox ? "radio-box" : ""
          } ${className}`}
          type="checkbox"
          name={name}
          id={id}
          defaultChecked={defaultChecked}
          onChange={onChange}
          onClick={onClick}
          title={title}
          value={value}
          readOnly={readOnly}
        />
      ) : (
        <input
          disabled={disabled}
          className={`inputs__filter-checkbox ${
            radioBox ? "radio-box" : ""
          } ${className}`}
          type="checkbox"
          name={name}
          id={id}
          checked={checked}
          onChange={onChange}
          onClick={onClick}
          value={value}
          readOnly={readOnly}
        />
      )}
    </div>
  );
}
